import type * as React from "react";
import Link from "next/link";
import { mainNav, siteConfig } from "@/lib/site/navigation";
import { Images, LucideMail, LucideMapPin, LucidePhoneCall } from "lucide-react";
import Image from "next/image";

export const Footer: React.FC = () => {
  return (
    <footer className="bg-zinc-900 dark:border-zinc-800 dark:bg-zinc-950">
      <div className="mx-8 py-10 sm:px-6 lg:px-8">
        <div className="grid grid-cols-3 gap-8">
          <div>
            <div className="flex flex-col gap-3">
              <div className="flex items-center gap-2">
                <LucidePhoneCall size={22} className="text-zinc-600"/>
                <a href="phoneto:03 9706 0006" className="text-xl font-medium text-zinc-400">039 7060 006</a>
              </div>

              <div className="flex items-center gap-2">
                <LucideMail size={22} className="text-zinc-600"/>
                <a href="mailto:info@aandjaycarrentals.com.au" className="text-xl font-medium text-zinc-400">info@aandjaycarrentals.com.au</a>
              </div>
              
            </div>

            <p className="mt-4 text-sm text-zinc-500 dark:text-zinc-400">
              A and Jay Car Rentals provides reliable, well maintained vehicles at affordable prices.
            </p>

            <div className="mt-8 flex gap-3">
              <Image src="/Icon/facebook.svg" width={24} height={24} alt="Facebook" className="filter brightness-0 invert opacity-40"/>
              <Image src="/Icon/instagram.svg" width={24} height={24} alt="Facebook" className="filter brightness-0 invert opacity-40"/>
            </div>

          </div>
          <div className="">
            <nav aria-label="Footer navigation">
              <ul className="flex flex-col gap-x-6 gap-y-4">
                {mainNav.map((item) => (
                  <li key={item.href}>
                    <Link
                      href={item.href}
                      className="text-md text-zinc-400 transition-colors hover:text-zinc-200"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
          <div className="flex flex-col gap-4">
            <div className="">
              <p className="text-lg font-semibold text-zinc-400 dark:text-zinc-400">
                Dandenong
              </p>
              <div className="flex gap-2 items-center">
                <LucideMapPin size={16} className="text-zinc-600"/>
                <p className="text-sm text-zinc-500 dark:text-zinc-400">
                  3, Plunkett Road, Dandenong, VIC 3175
                </p>
              </div>
              
              <div className="flex gap-2 items-center">
                <LucidePhoneCall size={16} className="text-zinc-600"/>
                <p className="text-sm text-zinc-500 dark:text-zinc-300">
                  039 7060 006
                </p>
              </div>
            </div>
            <div className="">
              <p className="text-lg font-semibold text-zinc-400 dark:text-zinc-400">
                Pakenham
              </p>
              <div className="flex gap-2 items-center">
                <LucideMapPin size={16} className="text-zinc-600"/>
                <p className="text-sm text-zinc-500 dark:text-zinc-400">
                  10 Southeast Blvd, Pakenham, VIC 3810
                </p>
              </div>
              
              <div className="flex gap-2 items-center">
                <LucidePhoneCall size={16} className="text-zinc-600"/>
                <p className="text-sm text-zinc-500 dark:text-zinc-300">
                  035 9411 414
                </p>
              </div>
            </div>
            <div className="">
              <p className="text-lg font-semibold text-zinc-400 dark:text-zinc-400">
                Oakleigh
              </p>
              <div className="flex gap-2 items-center">
                <LucideMapPin size={16} className="text-zinc-600"/>
                <p className="text-sm text-zinc-500 dark:text-zinc-400">
                  1715 Dandenong Rd, Oakleigh East, VIC 3166
                </p>
              </div>
              
              <div className="flex gap-2 items-center">
                <LucidePhoneCall size={16} className="text-zinc-600"/>
                <p className="text-sm text-zinc-500 dark:text-zinc-300">
                  039 2630 500
                </p>
              </div>
            </div>
          </div>
          
        </div>
        <p className="mt-8 border-t border-zinc-600 pt-6 text-center text-xs text-zinc-500 dark:border-zinc-800 dark:text-zinc-500">
          © {siteConfig.copyrightYear} {siteConfig.name}. All rights reserved.
        </p>
      </div>
    </footer>
  );
};
